<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          :parentRouteName="isBookingCenter() ? '' : 'BookingSelectList'"
          :extra-items="isBookingCenter() ? [
            '登記預約中心',
            bookingPreset.name ?? ''
          ] : [
            bookingPreset.name ?? ''
          ]"
        />
      </div>
    </div>

    <b-card>
      <div
        class="
          d-flex
          flex-column flex-xl-row
          align-items-start align-items-xl-center
          justify-content-between
          mb-4 mb-xl-2
        "
      >
        <h4 class="col-12 col-xl-4 mb-2 mb-xl-0 font-weight-bold">
          {{ bookingPreset.name }}
          <b-button
            class="mr-1"
            variant="inverse-dark"
            @click="showFormUrl(bookingPreset)"
          >
            <i class="fa fa-link"></i>
          </b-button>
        </h4>
        <div class="d-flex mb-2 mb-md-0">
          <b-form-select
            v-if="showReportSelect"
            v-model="selectedReportValue"
            :options="reportSelectOptions"
            class="report-select flex-shrink-0 mb-0 ml-2 mr-3"
            @change="handleReportChange"
          />

          <div class="flex-shrink-0 mr-3">
            <DateSearchPicker
              v-model="bookingBetween"
              startedPlaceholder="開始時間"
              endedPlaceholder="結束時間"
            />
          </div>

          <b-input-group class="">
            <b-form-input
              v-model="query.keyword"
              placeholder="搜尋"
              @keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="handleSearch"
                ><i class="fa fa-search"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>

          <b-button
            v-b-toggle.collapse-1-inner
            variant="link"
            class="flex-shrink-0 ml-0 ml-xl-1"
          >
            進階搜尋 <i class="fa fa-chevron-down"></i>
          </b-button>
        </div>
      </div>
      <div class="d-flex mb-4 mb-xl-2 justify-content-between">
        <div>
          <b-button
            v-if="checkPermission([consts.BOOKING_LIST_QUOTATION])"
            class="flex-shrink-0 mr-3"
            variant="outline-primary"
            @click="multipleCheck"
          >
            <i :class="isMultiSelectMode ? 'fa fa-times' : 'fa fa-check-square-o'"></i>{{ isMultiSelectMode ? '取消多選' : '多選' }}
          </b-button>

          <b-button
            v-if="checkPermission([consts.BOOKING_CREATE]) && bookingPreset.id"
            class="flex-shrink-0 mr-3"
            variant="primary"
            :to="
              isBookingCenter()
                ? {
                    name: 'BookingCenterBookingCreate',
                    params: { id: bookingPreset.id },
                    query: { branch_id: query.branch_id },
                  }
                : {
                    name: 'BookingCreate',
                    params: { id: bookingPreset.id },
                    query: { branch_id: query.branch_id },
                  }
            "
          >
            <i class="fa fa-plus"></i>
            新增預約
          </b-button>

          <b-button
            v-if="checkPermission([consts.BOOKING_PERIODIC_CREATE]) && bookingPreset.id"
            class="flex-shrink-0 mr-3"
            variant="primary"
            :to="{
              name: 'PeriodicBookingCreate',
              params: { preset_id: bookingPreset.id },
            }"
          >
            <i class="fa fa-plus"></i>
            新增週期性預約
          </b-button>
        </div>
        <div>
          <b-button
            class="flex-shrink-0 btn ml-3"
            variant="inverse-info"
            @click="goToPrintSelected"
            v-if="selectedBookingIds.length > 0 && checkPermission([consts.BOOKING_LIST_QUOTATION])"
          >
            <span class="mdi mdi-printer"></span> 產出估價單
          </b-button>

          <b-button
            class="flex-shrink-0 btn ml-3"
            variant="inverse-info"
            @click="handleExport"
          >
            <span class="mdi mdi-download"></span> 匯出
          </b-button>
        </div>
      </div>

      <b-collapse id="collapse-1-inner" class="mt-2">
        <div class="border p-2">
          <b-form class="">
            <!-- 一般模式搜尋欄位 -->
            <div class="d-flex flex-column flex-xl-row flex-wrap">
              <b-form-group
                label="狀態"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-select
                  class="mr-3"
                  :options="statusOptions"
                  v-model="query.status"
                  :disabled="showLoading"
                ></b-select>
              </b-form-group>
              <b-form-group
                label="更新時間"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <DateSearchPicker
                  class="mr-md-2 mr-0"
                  v-model="updatedBetween"
                  startedPlaceholder="開始時間"
                  endedPlaceholder="結束時間"
                />
              </b-form-group>
              <b-form-group
                label="會員名稱"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-form-input
                  class="mr-3"
                  v-model="query.customer_name"
                  placeholder="搜尋會員名稱"
                  :disabled="showLoading"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="會員編號"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-form-input
                  class="mr-3"
                  v-model="query.customer_outer_code"
                  placeholder="搜尋會員編號"
                  :disabled="showLoading"
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- 精靈模式搜尋欄位 -->
            <div v-if="showServiceSelect || showBranchSelect || showStaffSelect" class="d-flex flex-column flex-xl-row flex-wrap">
              <b-form-group
                v-if="showServiceSelect"
                label="服務"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-select
                  class="mr-3"
                  :options="serviceOptions"
                  v-model="query.service_id"
                  :disabled="showLoading"
                ></b-select>
              </b-form-group>
              <b-form-group
                v-if="showBranchSelect"
                label="分店"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <AppSingleSelect
                  class="mr-3"
                  v-model="branch"
                  :options="branchOptions"
                  @input="formatAndFetch"
                  :disabled="
                    showLoading ||
                    !this.checkPermission([consts.BOOKING_LIST_BRANCH])
                  "
                />
              </b-form-group>
              <b-form-group
                v-if="showStaffSelect"
                label="員工"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-select
                  class="mr-3"
                  :options="staffOptions"
                  v-model="query.staff_id"
                  :disabled="
                    showLoading || !query.branch_id || staffOptions.length <= 1
                  "
                ></b-select>
              </b-form-group>
            </div>

            <div class="flex-column">
              <b-button
                v-b-toggle.accordion-2
                variant="primary"
                class="mb-2 mb-xl-0 mr-2"
                @click="resetSearch"
                ><i class="mdi mdi-restart"></i> 重置搜尋條件</b-button
              >
              <b-button
                v-b-toggle.accordion-2
                variant="primary"
                class="mb-2 mb-xl-0"
                @click="handleSearch"
                ><i class="fa fa-search"></i> 搜尋
              </b-button>
            </div>
          </b-form>
        </div>
      </b-collapse>

      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="paginatedBookings"
                :fields="tableFields"
              >
                <template #head(_checkbox)>
                  <b-form-checkbox
                    :indeterminate="isIndeterminate"
                    :checked="isAllCurrentPageSelected"
                    @change="toggleSelectAll"
                  />
                </template>
                <template #cell(_checkbox)="data">
                  <b-form-checkbox :value="data.item.id" v-model="selectedBookingIds" />
                </template>
                <template #cell(title)="data">
                  <RouterLink
                    v-if="checkPermission([consts.BOOKING_EDIT])"
                    :to="linkUsedByBookingTitle(data.item)"
                  >
                    {{ data.value }}
                    <span class="mdi mdi-restore ml-2" v-if="data.item.periodicBookingId"></span>
                  </RouterLink>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template #cell()="data">
                  <template v-if="isObject(data.value)">
                    <RouterLink
                      v-if="
                        data.value.type === 'collection_select' &&
                        checkPermission([consts.COLLECTION_ITEM_MANAGE])
                      "
                      :to="{
                        name: 'CollectionItemEdit',
                        params: {
                          id: data.value.collection_id,
                          item_id: data.value.collection_item_id,
                        },
                      }"
                    >
                      {{ data.value.text }}
                    </RouterLink>
                    <template v-else>{{ data.value.text }}</template>
                  </template>
                  <template v-else-if="data.field.type === 'uploader'">
                    <a v-if="data.value" :href="data.value" target="_blank"
                      >（查看檔案）</a
                    >
                    <template v-else>（無檔案）</template>
                  </template>
                  <template v-else-if="data.field.is_dynamic_generated">{{
                    truncateText(data.value, 15)
                  }}</template>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template #cell(date)="data">
                  <span v-html="displayDate(data.item)"></span>
                </template>
                <template #cell(branch_id)="data">
                  <span>{{ data.item.branch?.name ?? '' }}</span>
                </template>
                <template #cell(staff_id)="data">
                  <span>{{ data.item.staff?.name ?? '' }}</span>
                </template>
                <template #cell(customer)="data">
                  <b-avatar
                    v-if="data.item.customer?.avatar_url"
                    class="mx-1"
                    size="2em"
                    :src="data.item.customer.avatar_url"
                  ></b-avatar>
                  <span v-if="data.item.customer?.name">{{ data.item.customer.name }}</span>
                  <span v-else class="text-muted">無會員</span>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.BOOKING_LIST_QUOTATION])"
                    variant="inverse-info"
                    :to="{
                      name: 'BookingCenterBookingPrint',
                      params: { id: bookingPreset.id },
                      query: { booking_ids: [data.item.id] },
                    }"
                  >
                    <span class="mdi mdi-printer"></span> 估價單
                  </b-button>
                  <b-dropdown
                    class="mr-1"
                    variant="secondary"
                    v-if="
                      checkPermission([consts.BOOKING_EDIT]) &&
                      updateStatusOptions.length > 0
                    "
                  >
                    <template slot="button-content">
                      <i class="mdi mdi-menu"></i>
                    </template>
                    <b-dropdown-item
                      v-if="checkPermission([consts.BOOKING_EDIT])"
                      @click="openStatusModal(data.item)"
                    >
                      變更狀態與推播
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.BOOKING_LIST])"
                    variant="inverse-primary"
                    :to="linkUsedByBookingViewButton(data.item)"
                  >
                    <span class="mdi mdi-eye"></span> 查看
                  </b-button>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.BOOKING_EDIT])"
                    variant="inverse-warning"
                    :to="linkUsedByBookingEditButton(data.item)"
                  >
                    <span class="mdi mdi-lead-pencil"></span> 編輯
                  </b-button>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.BOOKING_DELETE])"
                    variant="inverse-danger"
                    @click="deleteBooking(data.item)"
                  >
                    <span class="mdi mdi-delete"></span> 刪除
                  </b-button>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-card-text>
    </b-card>
    <b-modal
      id="form-status-modal"
      footer-class="d-flex justify-content-center"
      hide-header
    >
      <h5 class="mb-2">變更狀態與推播</h5>
      <h4>狀態</h4>
      <b-select
        class="mr-3"
        id="form-status"
        :options="updateStatusOptions"
        @change="changedStatus = true"
        v-model="selectedItemStatus"
      ></b-select>
      <template #modal-footer>
        <b-button
          size="lg"
          variant="danger"
          @click="
            $bvModal.hide('form-status-modal');
            changedStatus = false;
          "
          >關閉</b-button
        >
        <b-button size="lg" variant="success" @click="changeBookingStatus">{{
          changeBookingStatusWording
        }}</b-button>
      </template>
    </b-modal>
    <!-- <b-modal
      id="form-url-modal"
      footer-class="d-flex justify-content-center"
      hide-header
    >
      <h5 class="mb-2">填寫網址</h5>
      <b-textarea
        id="form-url"
        v-b-tooltip.click="'已複製'"
        v-model="formUrl"
        @click="copyFormUrl('#form-url')"
      ></b-textarea>
      <template v-if="!!recordUrl">
        <h5 class="my-2">填寫紀錄</h5>
        <b-textarea
          id="record-url"
          v-b-tooltip.click="'已複製'"
          v-model="recordUrl"
          @click="copyFormUrl('#record-url')"
        ></b-textarea>
      </template>
      <template #modal-footer>
        <b-button
          size="lg"
          variant="danger"
          @click="$bvModal.hide('form-url-modal')"
          >關閉</b-button
        >
      </template>
    </b-modal> -->
    <FormUrlModal ref="formUrlModal" />

    <ScopeDeleteModal
      ref="scopeDeleteModal"
      @confirm="handleScopeDeleteConfirm"
    />
  </div>
</template>

<script>
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import { format } from "date-fns";
import bookingApi from "@/apis/booking";
import branchApi from "@/apis/branch";
import collectionApi from "@/apis/collection";
import { mapState, mapGetters } from "vuex";
import DateSearchPicker from "@/components/Page/Dashboard/DateSearchPicker.vue";
import moment from "moment";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import BookingPresenter from "@/presenters/Booking.presenter.js"
import truncateText from "@/utils/truncateText";
import {
  updateQueryFromRoute,
  updateUrlWithoutReload,
} from "@/utils/updateUrl";
import generateLiffUrl from "@/mixins/Dashboard/liffUrlHelper";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import _ from "lodash";
import FormUrlModal from "@/components/Dashboard/Booking/FormUrlModal.vue";
import ScopeDeleteModal from "@/components/Dashboard/Booking/ScopeDeleteModal.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    DateSearchPicker,
    CustomPagination,
    AppSingleSelect,
    FormUrlModal,
    ScopeDeleteModal,
    BreadCrumb
  },
  mixins: [paginationMixin, generateLiffUrl],
  data() {
    const baseFields = [
      {
        key: "updated_at",
        label: "更新時間",
        sortable: true,
        formatter: (value) => {
          return format(new Date(value), "yyyy-MM-dd HH:mm:ss");
        },
      },
      { key: "actions", label: "管理" },
    ];
    return {
      consts: consts,
      branch: {},
      showLoading: false,
      fieldsInit: false,
      statusOptions: [],
      selectedItemStatus: null,
      selectedBooking: {},
      statusChanged: false,
      baseTableFields: baseFields,
      fields: [...baseFields],
      originalConfigFields: [],
      selectedReportValue: "default",
      combinedBookingsResponse: null,
      bookingPreset: {
        id: null,
        name: null,
        config: null,
        report_config: [],
      },
      collections: [],
      initialized: false,
      bookingBetween: {
        start_at: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        end_at: moment().add(1, 'month').format('YYYY-MM-DD'),
      },
      updatedBetween: {
        start_at: null,
        end_at: null,
      },
      query: {
        keyword: "",
        branch_id: null,
        staff_id: null,
        service_id: null,
        status: null,
        customer_name: "",
        customer_outer_code: "",
      },
      formUrl: null,
      recordUrl: null,
      staffOptions: [],
      isMultiSelectMode: false,
      selectedBookingIds: [],
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapGetters("general", ["myBranches", "currentBranch"]),
    startAtQueryCondition() {
      return this.bookingBetween.start_at
        ? moment(this.bookingBetween.start_at).format("YYYY-MM-DD 00:00:00")
        : null;
    },
    startDateQueryCondition() {
      return this.bookingBetween.start_at
        ? moment(this.bookingBetween.start_at).format("YYYY-MM-DD")
        : null;
    },
    endAtQueryCondition() {
      return this.bookingBetween.end_at
        ? moment(this.bookingBetween.end_at).format("YYYY-MM-DD")
        : null;
    },
    endDateQueryCondition() {
      return this.bookingBetween.end_at
        ? moment(this.bookingBetween.end_at).format("YYYY-MM-DD 23:59:59")
        : null;
    },
    updatedStartAtQueryCondition() {
      return this.updatedBetween.start_at
        ? moment(this.updatedBetween.start_at).format("YYYY-MM-DD 00:00:00")
        : null;
    },
    updatedEndAtQueryCondition() {
      return this.updatedBetween.end_at
        ? moment(this.updatedBetween.end_at).format("YYYY-MM-DD 23:59:59")
        : null;
    },
    queryWatcher() {
      return [
        this.query.keyword,
        this.query.branch_id,
        this.query.staff_id,
        this.startDateQueryCondition,
        this.endDateQueryCondition,
        this.query.status,
      ].join("-");
    },
    updateStatusTitle() {
      const fieldId =
        this.bookingPreset.config?.booking_mapping?.bookings?.status;
      const field = this.bookingPreset.config?.fields.find(
        (f) => f._id === fieldId
      );
      if (field) {
        return field.config?.title ?? field.title;
      } else {
        return [];
      }
    },
    updateStatusOptions() {
      const fieldId =
        this.bookingPreset.config?.booking_mapping?.bookings?.status;
      const field = this.bookingPreset.config?.fields.find(
        (f) => f._id === fieldId
      );
      if (field) {
        return field.config?.options ?? field.options;
      } else {
        return [];
      }
    },
    serviceOptions() {
      const collections = this.collections.find(
        (col) => col.id == this.bookingPreset.config?.service?.collection_id
      );
      const fieldId = this.bookingPreset.config?.service?.title_item_id;
      return (
        collections?.items?.map((item) => {
          let field = item.data.find((d) => d.field_id == fieldId);
          return {
            value: item.id,
            text: field.value,
          };
        }) ?? []
      );
    },
    branchOptions() {
      return this.myBranches.map((branch) => {
        let branchName = `${branch.branch_code} ${branch.name}`;
        return {
          value: branch.id,
          text: branchName,
        };
      });
    },
    showBranchSelect() {
      return this.bookingPreset?.config?.branch?.field_id;
    },
    showStaffSelect() {
      return (
        this.bookingPreset?.type == "wizard" &&
        this.bookingPreset?.config?.enabled_selected_staff
      );
    },
    showServiceSelect() {
      return (
        this.bookingPreset?.type == "wizard" &&
        this.bookingPreset.config?.service?.collection_id
      );
    },
    changeBookingStatusWording() {
      // this.selectedBooking.status 原始的狀態
      if (this.bookingPreset.config.status_change_events) {
        if (
          this.bookingPreset.config.status_change_events.find(
            (event) => event.booking_status == this.selectedItemStatus
          )
        ) {
          if (this.selectedBooking.status == this.selectedItemStatus) {
            return "重新推播";
          } else {
            return "變更狀態與推播";
          }
        } else {
          return "變更狀態";
        }
      }
      return "變更狀態";
    },
    tableFields() {
      return this.isMultiSelectMode
        ? [{ key: "_checkbox", label: "" }, ...this.fields]
        : this.fields;
    },
    showReportSelect() {
      return (
        Array.isArray(this.bookingPreset.report_config) &&
        this.bookingPreset.report_config.length >= 1
      );
    },
    reportSelectOptions() {
      const options = [
        {
          value: "default",
          text: this.bookingPreset.name ?? "預設",
        },
      ];
      (this.bookingPreset.report_config ?? []).forEach((report, index) => {
        options.push({
          value: index,
          text: report.title || `報表 ${index + 1}`,
        });
      });
      return options;
    },
    isAllCurrentPageSelected() {
      if (!this.paginatedBookings.length) return false;
      const currentIds = this.paginatedBookings.map((b) => b.id);
      return currentIds.every((id) => this.selectedBookingIds.includes(id));
    },
    isIndeterminate() {
      const currentIds = this.paginatedBookings.map((b) => b.id);
      const selectedOnPage = currentIds.filter((id) =>
        this.selectedBookingIds.includes(id)
      ).length;
      return selectedOnPage > 0 && selectedOnPage < currentIds.length;
    },
    allBookings() {
      return (this.combinedBookingsResponse?.data || []).map((booking) => {
        const bookingPresenter = BookingPresenter.create(booking, this.bookingPreset, this.collections)
        const isPeriodic = booking.is_periodic || false;
        const periodicBookingId = booking.periodic_booking_id;
        const occurrenceDate = isPeriodic ? moment(booking.start_at).format('YYYY-MM-DD') : null;

        return {
          title: bookingPresenter.title,
          ...booking,
          ...bookingPresenter.fieldDataInString,
          isPeriodic,
          periodicBookingId,
          occurrenceDate
        }
      });
    },
    paginatedBookings() {
      // Client-side pagination: slice allBookings based on current page
      const page = parseInt(this.query.page, 10) || 1;
      const perPage = parseInt(this.query.per_page, 10) || 10;
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      return this.allBookings.slice(startIndex, endIndex);
    },
    totalRows() {
      return this.allBookings.length;
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$route);
        this.fetchBookings();
      },
    },
    "query.branch_id": {
      async handler(val) {
        if (val) {
          await this.fetchStaff();
        } else {
          this.staffOptions = [
            {
              value: null,
              text: "全部",
            },
          ];
        }
      },
    },
  },
  async mounted() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
    this.bookingPreset.id = this.$route.params.id;
    if (!this.bookingPreset.id) {
      await this.$swal("錯誤", "找不到預約設定檔", "error");
      return;
    }
    await this.fetchBookingPreset();
    if (this.showBranchSelect) {
      if (this.currentBranch) {
        this.query.branch_id = this.currentBranch.id;
        this.branch = this.branchOptions.find(
          (branch) => branch.value === this.currentBranch.id
        );
      }
    }
    this.fetchBookings();
    this.getStatusOptions();
    this.fetchFields();
    this.initialized = true;
  },
  methods: {
    truncateText,
    formatAndFetch() {
      this.query.branch_id = this.branch.value;
    },
    linkUsedByBookingTitle(booking) { // booking here might be a one-time booking or a periodic booking
      if (booking.periodicBookingId && booking.id) {
        return {
          name: 'PeriodicBookingEdit',
          params: {
            id: this.bookingPreset.id,
            periodic_booking_id: booking.periodicBookingId,
            booking_id: booking.id,
            date: moment(booking.start_at).format('YYYY-MM-DD'),
          },
        }
      }

      if (booking.isPeriodic) {
        return {
          name: 'PeriodicBookingEdit',
          params: {
            id: this.bookingPreset.id,
            periodic_booking_id: booking.periodicBookingId,
            date: booking.occurrenceDate,
          },
        }
      }

      if (this.isBookingCenter()) {
        return {
          name: 'BookingCenterBookingEdit',
          params: {
            id: this.bookingPreset.id,
            booking_id: booking.id,
          },
        }
      }

      return {
        name: 'BookingEdit',
        params: {
          id: this.bookingPreset.id,
          booking_id: booking.id,
        },
      }
    },
    linkUsedByBookingViewButton(booking) {
      if (!this.bookingPreset.id) {
        return null
      }

      if (this.isBookingCenter()) {
        return {
          name: 'BookingCenterBookingView',
          params: {
            id: this.bookingPreset.id,
            booking_id: booking.id,
          },
        }
      }

      return {
        name: 'BookingView',
        params: {
          id: this.bookingPreset.id,
          booking_id: booking.id,
        },
      }
    },
    linkUsedByBookingEditButton(booking) { // booking here might be a regular booking or a periodic booking
      if (booking.periodicBookingId && booking.id) {
        return {
          name: 'PeriodicBookingEdit',
          params: {
            id: this.bookingPreset.id,
            periodic_booking_id: booking.periodicBookingId,
            date: moment(booking.start_at).format('YYYY-MM-DD'),
          },
          query: {
            booking_id: booking.id,
          },
        }
      }

      if (booking.isPeriodic) {
        return {
          name: 'PeriodicBookingEdit',
          params: {
            id: this.bookingPreset.id,
            periodic_booking_id: booking.periodicBookingId,
            date: booking.occurrenceDate,
          },
        }
      }

      if (this.isBookingCenter()) {
        return {
          name: 'BookingCenterBookingEdit',
          params: {
            id: this.bookingPreset.id,
            booking_id: booking.id,
          },
        }
      }

      return {
        name: 'BookingEdit',
        params: {
          id: this.bookingPreset.id,
          booking_id: booking.id,
        },
      }
    },
    async submitUpdateStatus() {
      try {
        this.showLoading = true;
        await bookingApi.updateBookingStatus(
          this.bookingPreset.id,
          this.selectedBooking.id,
          {
            field_id:
              this.bookingPreset.config?.booking_mapping?.bookings?.status,
            title: this.updateStatusTitle,
            status: this.selectedItemStatus,
          }
        );
        this.$swal("更新成功", "", "success");
        this.statusChanged = true;
        await this.fetchBookings();
      } catch (error) {
        console.error(error);
        this.$swal("更新失敗", "", "error");
      } finally {
        this.showLoading = false;
      }
    },
    changeBookingStatus() {
      this.statusChanged = false;
      this.submitUpdateStatus();
      this.$bvModal.hide("form-status-modal");
    },
    openStatusModal(item) {
      this.selectedItemStatus = item.status;
      this.selectedBooking = item;
      this.$bvModal.show("form-status-modal");
    },
    async getStatusOptions() {
      const { data } = await bookingApi.getBookingOptions(
        this.bookingPreset.id
      );
      this.statusOptions = data.status_mapping.map((status) => {
        return {
          value: status,
          text: status,
        };
      });
      this.statusOptions.push({
        value: null,
        text: "全部",
      });
    },
    async fetchStaff() {
      const { data } = await branchApi.getBranchStaffs(this.query.branch_id);
      this.staffOptions = data.data.map((staff) => {
        return {
          value: staff.id,
          text: staff.name,
        };
      });

      this.staffOptions.unshift({
        value: null,
        text: "全部",
      });
    },
    isBookingCenter() {
      return this.$route.name.includes("BookingCenter");
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    displayDate(item) {
      // 檢查 start_at 和 end_at 並轉換為 Date 對象
      const startAt = item.start_at ? new Date(item.start_at) : null;
      const endAt = item.end_at ? new Date(item.end_at) : null;

      // 格式化日期為 "YYYY-MM-DD HH:mm"
      const formatDateTime = (date) => {
        if (!date) return ""; // 如果日期為 null，返回空字串

        return date.toLocaleString("zh-TW", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
      };

      const formattedStartAt = startAt ? formatDateTime(startAt) : ""; // 格式化 start_at
      const formattedEndAt = endAt ? formatDateTime(endAt) : ""; // 格式化 end_at

      // 返回格式化后的日期，使用 <br> 換行
      return `${formattedStartAt} ${
        formattedStartAt && formattedEndAt ? "~<br>" : ""
      } ${formattedEndAt}`;
    },
    getFieldId(field) {
      return field?._id ?? field?.config?._id;
    },
    resolveConfigFieldsFromReport(fieldIds) {
      if (!Array.isArray(fieldIds)) {
        return [];
      }

      const specialKeys = new Set([
        "booking_number",
        "branch_title",
        "staff_title",
        "service_title",
      ]);

      return fieldIds
        .filter((fieldId) => !specialKeys.has(fieldId))
        .map((fieldId) =>
          this.originalConfigFields.find(
            (field) => this.getFieldId(field) === fieldId
          )
        )
        .filter(Boolean);
    },
    applyReportSelection(reportValue = this.selectedReportValue) {
      if (reportValue === "default") {
        this.bookingPreset.config.fields = _.cloneDeep(
          this.originalConfigFields
        );
        return null;
      }

      const reportIndex = Number(reportValue);
      const report = this.bookingPreset.report_config?.[reportIndex];
      if (!report) {
        return null;
      }

      this.bookingPreset.config.fields = this.resolveConfigFieldsFromReport(
        report.fields
      );
      return report.fields ?? [];
    },
    createServiceFieldFormatter() {
      return (value) => {
        if (!value) {
          return "";
        }
        const collections = this.collections.find(
          (col) =>
            col.id == this.bookingPreset.config?.service?.collection_id
        );
        const fieldId = this.bookingPreset.config?.service?.title_item_id;
        const items = collections?.items?.filter((item) =>
          value.includes(item.id)
        );
        if (items) {
          return items
            .map((item) => {
              const i = item.data.find((data) => data.field_id == fieldId);
              return i.value || i.text;
            })
            .join(", ");
        }
        return "";
      };
    },
    async ensureServiceCollectionLoaded() {
      if (!this.bookingPreset.config?.service?.collection_id) {
        return;
      }

      if (
        this.collections.find(
          (col) =>
            col.id == this.bookingPreset.config?.service?.collection_id
        )
      ) {
        return;
      }

      const collectionResponse = await collectionApi.getCollection(
        this.bookingPreset.config?.service?.collection_id
      );
      this.collections.push(collectionResponse.data.data);
    },
    async buildDynamicFieldConfig(field) {
      if (field.config?.list_hidden === true || field.list_hidden === true) {
        return null;
      }

      const fieldConfig = {
        key: this.getFieldId(field),
        label: field.title ?? field.config.title,
        sortable: true,
        type: field.type,
        is_dynamic_generated: true,
      };
      const collectionId = field.collection_id ?? field.config?.collection_id;

      if (
        ["collection_select", "collection_carousel"].includes(field.type) &&
        !this.collections.find((collection) => collection.id === collectionId)
      ) {
        try {
          const collectionResponse = await collectionApi.getCollection(
            collectionId,
            {
              with_all_items: true,
            }
          );
          this.collections.push(collectionResponse.data.data);
        } catch (error) {
          this.$swal("資料載入錯誤", `資料集 ${collectionId} 不存在`, "error");
          console.error(error);
        }
      }

      return fieldConfig;
    },
    async buildWizardFieldConfig(fieldKey) {
      const wizardFieldMap = {
        branch_title: {
          key: "branch_id",
          label: "分店",
          index: 3,
          enabled: this.bookingPreset.config?.enabled_selected_branch,
        },
        staff_title: {
          key: "staff_id",
          label: "員工",
          index: 4,
          enabled: this.bookingPreset.config?.enabled_selected_staff,
        },
        service_title: {
          key: "service_id",
          label: "服務",
          index: 5,
          enabled: !!this.bookingPreset.config?.service?.collection_id,
        },
      };

      const wizardField = wizardFieldMap[fieldKey];
      if (!wizardField?.enabled) {
        return null;
      }

      if (fieldKey === "service_title") {
        await this.ensureServiceCollectionLoaded();
        return {
          key: wizardField.key,
          label: wizardField.label,
          index: wizardField.index,
          formatter: this.createServiceFieldFormatter(),
        };
      }

      return {
        key: wizardField.key,
        label: wizardField.label,
        index: wizardField.index,
      };
    },
    async buildTableFields(reportFieldIds = null) {
      const newField = [];
      const configFields = this.bookingPreset.config?.fields ?? [];
      const useReportOrder = Array.isArray(reportFieldIds);

      if (useReportOrder) {
        for (const fieldKey of reportFieldIds) {
          if (this.bookingPreset.type === "wizard") {
            const wizardFieldConfig = await this.buildWizardFieldConfig(
              fieldKey
            );
            if (wizardFieldConfig) {
              newField.push(wizardFieldConfig);
              continue;
            }
          }

          const field = configFields.find(
            (item) => this.getFieldId(item) === fieldKey
          );
          if (!field) {
            continue;
          }

          const fieldConfig = await this.buildDynamicFieldConfig(field);
          if (fieldConfig) {
            newField.push(fieldConfig);
          }
        }
      } else {
        for (const field of configFields) {
          const fieldConfig = await this.buildDynamicFieldConfig(field);
          if (fieldConfig) {
            newField.push(fieldConfig);
          }
        }

        if (this.bookingPreset.type === "wizard") {
          console.log(this.bookingPreset.config);
          if (this.bookingPreset.config?.enabled_selected_branch) {
            newField.push({
              key: "branch_id",
              label: "分店",
              index: 3,
            });
          }

          if (this.bookingPreset.config?.enabled_selected_staff) {
            newField.push({
              key: "staff_id",
              label: "員工",
              index: 4,
            });
          }

          if (this.bookingPreset.config?.service?.collection_id) {
            await this.ensureServiceCollectionLoaded();
            newField.push({
              key: "service_id",
              label: "服務",
              index: 5,
              formatter: this.createServiceFieldFormatter(),
            });
          }
        }
      }

      this.fields = [
        { key: "title", label: "標題", sortable: false },
        { key: "date", label: "起迄時間" },
        { key: "customer", label: "預約會員" },
        ...newField,
        ..._.cloneDeep(this.baseTableFields),
      ];

      if (!useReportOrder) {
        this.fields
          .filter((field) => Object.keys(field).includes("index"))
          .forEach((field) => {
            this.fields.splice(this.fields.indexOf(field), 1);
            this.fields.splice(field.index, 0, field);
          });
      }
    },
    async handleReportChange(reportValue) {
      console.log(reportValue);
      const reportFieldIds = this.applyReportSelection(reportValue);
      await this.buildTableFields(reportFieldIds);
      await this.fetchFields();
      if (this.initialized) {
        await this.fetchBookings();
      }
    },
    async fetchBookingPreset() {
      try {
        this.showLoading = true;
        const response = await bookingApi.getBookingPreset(
          this.bookingPreset.id
        );
        this.bookingPreset = response.data.data;
        this.originalConfigFields = _.cloneDeep(
          this.bookingPreset.config?.fields ?? []
        );
        this.selectedReportValue = "default";

        if (
          !this.bookingPreset.config?.fields ||
          this.bookingPreset.config.fields.length === 0
        ) {
          this.$swal("提醒", "此預約尚未設定欄位。", "warning");
        }

        await this.buildTableFields();
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取設定錯誤", "error");
      } finally {
        this.showLoading = false;
      }
    },
    async fetchBookings() {
      try {
        this.showLoading = true;
        const params = {
          ...this.query,
          start_at: this.startAtQueryCondition,
          end_at: this.endDateQueryCondition, // Use endDateQueryCondition for end_at to match YYYY-MM-DD 23:59:59
          updated_start_at: this.updatedStartAtQueryCondition,
          updated_end_at: this.updatedEndAtQueryCondition,
        };

        this.combinedBookingsResponse = await bookingApi.getCombinedBookings(this.bookingPreset.id, params);
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取資料集項目錯誤", "error");
      } finally {
        this.showLoading = false;
      }
    },
    async deleteBooking(booking) {
      // Check if this is a periodic booking
      if (booking.isPeriodic) {
        this.$refs.scopeDeleteModal.show(booking, booking.occurrenceDate);
        return;
      }

      // Handle normal booking deletion
      try {
        this.showLoading = true;
        const result = await this.$swal({
          title: "刪除預約",
          text: `是否要將此預約刪除？`,
          type: "warning",
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonText: "取消",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "移除",
          reverseButtons: true,
        });

        if (!result.value) {
          return;
        }

        await bookingApi.deleteBooking(this.bookingPreset.id, booking.id);
        this.$swal("刪除成功", "", "success");
        await this.fetchBookings();
      } catch (error) {
        console.error(error);
        this.$swal("刪除失敗", "", "error");
      } finally {
        this.showLoading = false;
      }
    },
    async handleScopeDeleteConfirm({ scope, target_date, periodicBooking }) {
      try {
        this.$refs.scopeDeleteModal.setLoading(true);

        const params = {
          scope,
          target_date
        };

        await bookingApi.deletePeriodicBooking(periodicBooking.periodicBookingId, params);
        this.$refs.scopeDeleteModal.hide();
        this.$swal("刪除成功", "", "success");
        await this.fetchBookings();
      } catch (error) {
        console.error(error);
        this.$swal("刪除失敗", error.response?.data?.message || "", "error");
      } finally {
        this.$refs.scopeDeleteModal.setLoading(false);
      }
    },
    isObject(field) {
      return typeof field === "object" && field !== null;
    },
    showFormUrl(bookingPreset) {
      // this.formUrl = this.generateLiffUrl(`booking/form/${bookingPreset.id}`);
      // this.recordUrl = this.generateLiffUrl(`booking/${bookingPreset.id}`);
      // this.$bvModal.show("form-url-modal");
      this.$refs.formUrlModal.showFormUrl(bookingPreset);
    },
    // copyFormUrl(id) {
    //   const inputText = document.querySelector(id);
    //   inputText.select();
    //   document.execCommand("copy");
    // },
    resetSearch() {
      this.query = {
        per_page: 10,
        page: 1,
        keyword: "",
        branch_id: null,
        staff_id: null,
        service_id: null,
        status: null,
        customer_name: null,
        customer_outer_code: null,
        with_customer_profile: true,
      };

      if (this.showBranchSelect) {
        if (this.currentBranch) {
          this.query.branch_id = this.currentBranch.id;
          this.branch = this.branchOptions.find(
            (branch) => branch.value === this.currentBranch.id
          );
        }
      }

      this.bookingBetween = {
        start_at: null,
        end_at: null,
      };
      this.updatedBetween = {
        start_at: null,
        end_at: null,
      };
    },
    handlePageChange(page) {
      this.query.page = parseInt(page, 10);
      updateUrlWithoutReload(this.query, this.$store, this.$route);
    },
    handlePerPageChange(perPage) {
      this.query.per_page = parseInt(perPage, 10);
      this.query.page = 1; // Reset to first page when changing items per page
      updateUrlWithoutReload(this.query, this.$store, this.$route);
    },
    handleSearch() {
      if (!this.initialized) return;
      this.query.page = 1; // Reset to first page when searching
      updateUrlWithoutReload(this.query, this.$store, this.$route);
      this.fetchBookings();
    },
    async handleExport() {
      try {
        this.showLoading = true;

        const params = {
          ...this.query,
          start_at: this.startAtQueryCondition,
          end_at: this.endAtQueryCondition,
          updated_start_at: this.updatedStartAtQueryCondition,
          updated_end_at: this.updatedEndAtQueryCondition,
          with_all_items: true,
          with_trashed: true,
          report: this.selectedReportValue,
        };

        await bookingApi.exportBookings(this.bookingPreset.id, params);

        this.$swal({
          title: "成功",
          text: "可至“我的主控台”查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } finally {
        this.showLoading = false;
      }
    },
    async fetchFields() {
      let normalizeProfileFields = await this.normalizeProfileFields();
      let fields = _.cloneDeep(this.fields);

      // 找到插入的位置
      const insertIndex =
        fields.findIndex((field) => field.key === "customer") + 1;

      // 創建新的欄位陣列，插入 normalizeProfileFields
      this.fields = [
        ...fields.slice(0, insertIndex), // 從開頭到插入點之前的欄位
        ...normalizeProfileFields, // 插入 normalizeProfileFields
        ...fields.slice(insertIndex), // 插入點之後的欄位
      ];
    },
    async normalizeProfileFields() {
      const customerList = this.getModuleConfig(
        "customer",
        "booking.customer_list"
      );

      const profileMappings = customerList?.[0]?.member_fields ?? [];

      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    multipleCheck() {
      this.isMultiSelectMode = !this.isMultiSelectMode;
      if (!this.isMultiSelectMode) {
        this.selectedBookingIds = [];
      }
    },
    goToPrintSelected() {
      if (!this.selectedBookingIds.length) return;
      this.$router.push({
        name: 'BookingCenterBookingPrint',
        params: { id: this.bookingPreset.id },
        query: { booking_ids: this.selectedBookingIds },
      });
    },
    toggleSelectAll(checked) {
      const currentIds = this.paginatedBookings.map((b) => b.id);
      if (checked) {
        const unique = new Set([...this.selectedBookingIds, ...currentIds]);
        this.selectedBookingIds = Array.from(unique);
      } else {
        this.selectedBookingIds = this.selectedBookingIds.filter(
          (id) => !currentIds.includes(id)
        );
      }
    },
  },
};
</script>
<style scoped>
.report-select {
  width: auto !important;
  max-width: 220px;
  min-width: 140px;
  flex: 0 0 auto;
}

.row-searchbar {
  width: 80%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>
